import React, { Component } from "react";
import "./index.css";

export default class MediaCoverageSection extends Component {
  render() {
    return (
      <div id="mediacovergesection" >
        <div className="landing-header" style={{ marginTop: "10rem" }}>
          <h1>Press Coverage</h1>
        </div>
        <div>
          <ul className='ul-2-cols' >
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.business-standard.com/article/news-ani/marconi-society-s-celestini-program-recognizes-indian-students-tackling-women-s-safety-and-air-pollution-119102101055_1.html'> [Business Standard] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.thehindubusinessline.com/news/variety/delhi-students-solutions-for-womens-safety-air-pollution-bag-marconi-societys-celestini-programme-awards/article29765200.ece'> [The Hindu] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.businesswireindia.com/marconi-societys-celestini-program-recognizes-indian-students-tackling-womens-safety-and-air-pollution-65462.html'> [Business Wire] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.asianage.com/technology/in-other-news/281019/finally-a-womens-safety-app-that-makes-sense.html'> [The Asian Age] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.downtoearth.org.in/news/science-technology/an-app-that-can-detect-distress-speech-and-trigger-sos-67354'> [DownToEarth] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.indiatoday.in/education-today/news/story/delhi-college-students-win-prestigious-marconi-awards-for-apps-on-women-safety-and-checking-air-pollution-1611854-2019-10-22'> [India Today] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.zeebiz.com/technology/news-women-safety-air-pollution-apps-win-marconi-awards-112897'> [Zee Business] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.gstimes.in/science-rakshak-an-app-that-can-detect-distress-speech-and-trigger-sos/'> [GS TIMES] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.aninews.in/news/business/marconi-societys-celestini-program-recognizes-indian-students-tackling-womens-safety-and-air-pollution20191021193810/'> [ANI News] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.financialexpress.com/industry/technology/benefits-of-connectivity-students-win-marconi-awards-for-innovative-apps/1747344/'> [Financial Express] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://vigyanprasar.gov.in/isw/An-app-that-can-detect-distress-speech-and-trigger-SOS.html'> [Indian Science Wire (VigyanPrasar)] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.outlookindia.com/newsscroll/women-safety-air-pollution-apps-win-marconi-awards/1645577'> [Outlook India] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.indiatechonline.com/it-happened-in-india.php?id=3581'> [India Tech] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.indiacityblog.com/ians/women-safety-air-pollution-apps-win-marconi-awards-lead-13343/'> [India City Blog] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.newkerala.com/news/read/233288/women-safety-air-pollution-apps-win-marconi-awards.html'> [newKerela] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://tfipost.com/ians-news/women-safety-air-pollution-apps-win-marconi-awards/'> [TFI Post] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://indusdictum.com/2019/10/22/smartphone-app-detect-distress-speech-trigger-sos/'> [Indus Dictum] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='http://bright9news.com/2019/10/22/women-safety-air-pollution-apps-win-marconi-awards'> [Bright9News] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://news.webindia123.com/news/articles/Science/20191022/3619165.html'> [webIndia123] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='https://www.hastakshepnews.com/an-app-that-can-detect-distress-speech-and-trigger-sos/'> [Hastakshep News] </a>
            </li>
            <li type='disc' style={{color:'white'}}>
              <a className='white-anchor' target='_blank' href='http://www.lopscoop.com/content?id=186985'> [LopScoop] </a>
            </li>



          </ul>
        </div>
      </div>
    );
  }
}
